module.exports = __webpack_public_path__ + "img/Führungsstaffel.6a1b3d00.svg";